/**
 * Build a playable absolute URL for a video stored on the backend.
 *
 * The DB stores `video_url` as a relative path like `/api/media/videos/abc.mp4`.
 * The HTML <video> tag cannot send Authorization headers, so we:
 *   1. Convert the path to an absolute URL on the API host.
 *   2. Append the user's JWT as `auth_token` query param so the backend
 *      can authorise the stream request.
 *
 * For external URLs (http(s)://...), we return them unchanged so YouTube /
 * direct CDN links keep working.
 */
export function buildVideoSrc(videoUrl, authToken) {
  if (!videoUrl) return '';
  // Already absolute (e.g. https://...)
  if (/^https?:\/\//i.test(videoUrl)) return videoUrl;

  const raw = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');
  // Strip trailing /api so we can compose with paths that already include /api
  const origin = raw.replace(/\/api$/, '');
  const sep = videoUrl.includes('?') ? '&' : '?';
  if (!authToken) return `${origin}${videoUrl}`;
  return `${origin}${videoUrl}${sep}auth_token=${encodeURIComponent(authToken)}`;
}
